import styled from 'styled-components';
import { Col, Row } from 'antd';

export const LoggedInUserContainer = styled.div`
  width: 475px;

  @media (max-width: 768px) {
    width: auto;
  }

  background-color: white;
  padding: 25px 20px 25px 20px;
  color: black;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);

  > p {
    margin-bottom: 10px;
  }
`;

export const LoggedInUserRow = styled(Row)`
  padding: 16px 20px 16px 20px;
  border: solid 1px #e5ebee;
  border-radius: 4px;
  margin-bottom: 25px;
`;

export const LoggedInUserCol = styled(Col)`
  display: flex;
  align-self: center;
  > div {
    margin-right: 20px;
  }
  > p {
    margin: auto 0 auto 0;
    display: block;
  }
`;
